<template>
  <MediaOwners
    :can-be-removed="canBeRemoved"
    :entity="entity"
    :is-read-only="isReadOnly"
    :tiles-are-readonly="false"
    :is-multiselect="true"
    :selected-media-owners-i-ds="selectedMediaOwnersIDs"
    :is-new="entity?.id === -1"
    @changed="onMediaOwnersSelectionChanged"
    @cleared="clear" />
</template>

<script setup lang="ts">
  import { computed, ComputedRef } from 'vue';

  import { Organization } from '@/common/models';
  import Plan from '@/common/models/plan/Plan';
  import { mapActions } from '@/utils/StateMapping';

  import MediaOwners from './MediaOwners.vue';

  interface IPlanMediaOwnersProps {
    entity: Plan;
    canBeRemoved: boolean;
    isReadOnly: boolean;
  }

  interface IPlanMediaOwnerEmits {
    (e: 'changed', value: number[], selectedMOs: Organization[]): void;
    (e: 'cleared'): void;
  }

  // Props

  const { entity, canBeRemoved, isReadOnly } = defineProps<IPlanMediaOwnersProps>();

  // Emits

  const emit = defineEmits<IPlanMediaOwnerEmits>();

  // Computed

  const selectedMediaOwnersIDs: ComputedRef<number[]> = computed(() => entity.mediaOwnerIDs?.filter((x) => x != null));

  // Methods

  const { updatePlanMediaOwnerIDs } = mapActions();

  function onMediaOwnersSelectionChanged(mediaOwnersIDs: number[], selectedMOs: Organization[]) {
    updatePlanMediaOwnerIDs({ plan: entity, value: mediaOwnersIDs });
    emit('changed', mediaOwnersIDs, selectedMOs);
  }

  function clear(availableMediaOwnersIDs: number[]) {
    updatePlanMediaOwnerIDs({ plan: entity, value: availableMediaOwnersIDs });
    emit('cleared');
  }
</script>
